<template>
    <div class="home">
        <img src="../static/bg.jpg" class="bg" alt="">
        <img src="../static/star1.png" class="star1" alt="">
        <img src="../static/star2.png" class="star2" alt="">

        <img src="../static/header1.png" class="header1" alt="">

        <img src="../static/header.png" class="header" alt="">
        <img src="../static/hangzhou.png" class="hangzhou" alt="">
        <img src="../static/jinhua.png" class="jinhua" alt="">
        <img src="../static/button1.png" class="button" @click="toshow" alt="">
        <van-icon name="down" class="down" />
        <img src="../static/jxw.png" class="jxw" alt="">

        <div class="bottom-box">
            <img src="../static/11.jpg" class="bottom-img" alt="">
            <!-- <img src="../static/logo.png" class="logo" alt=""> -->
        </div>

        <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
        <!-- <img src="../static/tip.png" class="tip" alt=""> -->
        <van-overlay :show="show">
            <div class="wrapper" @click.stop>
                <van-icon name="close" class="close" @click="close" />
                <img src="../static/share1.png" class="share" alt="">
                <div class="thewords">
                    <p>转发到朋友圈，</p>
                    <p>邀请更多人助力火炬传递</p>
                </div>

                <div class="box">
                    <div class="words">
                        <p>
                            你是第 <span style="color: #FEEE35;">{{ currentVal }}</span> 位
                        </p>
                        <p style="color: #FEEE35;">助力人</p>
                    </div>

                </div>
            </div>
        </van-overlay>

        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
    </div>
</template>

<script>
import { postRequest } from '../untils/api'
export default {
    data() {
        return {
            show: false,
            // 目标数字
            endVal: 0,
            // 动画持续时间（单位：毫秒）
            duration: 1000,
            // 当前数字，初始值为0
            currentVal: 0,
            // 动画开始时间
            startTime: null,
            music: true
        }
    },
    methods: {
        close() {
            this.show = false
            this.startTime = null

        },
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                audio.volume = 0.6;
                audio.play();
            }
        },
        toshow() {


            if (this.music) {
                document.getElementById('audio').play();
            }
            // postRequest('/num/').then(res => {
            //     this.endVal = res.data.data
            // })
            this.endVal = 32522
            this.show = true
            this.startCount()
        },
        startCount() {
            // 使用requestAnimationFrame()方法实现动画效果
            window.requestAnimationFrame(timestamp => {
                // 如果startTime属性为空，则将当前时间赋值给它
                if (!this.startTime) this.startTime = timestamp
                // 计算当前时间与动画开始时间之间的时间差，以及时间差所占总时间的百分比
                const progress = timestamp - this.startTime
                const percentage = Math.min(progress / this.duration, 1)
                // 根据时间百分比计算当前数字，并将其赋值给currentVal属性
                this.currentVal = Math.floor(percentage * (this.endVal - 0) + 0)
                // 如果动画持续时间还没有达到，则继续循环调用startCount()方法
                if (progress < this.duration) {
                    this.startCount()
                }
            })
        },
        androidplay() {
            document.getElementById('audio').volume = 0.6;
            document.getElementById('audio').play();




            if (navigator.userAgent.indexOf("Android") > 0) {
                //如果是Android的话，在判断是否是微信端打开链接
                function is_weixn() {
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        return true;
                    } else {
                        return false;
                    }
                }
                //如果是在Android端微信打开 触摸播放
                if (is_weixn()) {
                    document.addEventListener('touchstart', () => {

                        if (this.music) {
                            document.getElementById('audio').volume = 0.6;
                            document.getElementById('audio').play();
                        }


                    })
                } else {
                }
            }
        },
    },
    mounted() {
        this.androidplay()
        document.addEventListener("WeixinJSBridgeReady", function () {
            document.getElementById('audio').volume = 0.6;
            document.getElementById('audio').play();
        }, false);

        document.addEventListener('touchstart', () => {

            if (this.music) {
                document.getElementById('audio').volume = 0.6;
                document.getElementById('audio').play();
            }


        })
    },
}
</script>

<style lang="less" scoped>
.home {
    // background: url("../static/bg.jpg") no-repeat;
    // background-size: 100% 100%;
    width: 100%;

    background-color: #CB69FC;
    position: relative;

    .bg {
        top: -50px;
        position: relative;
        width: 100%;

    }

    .star1 {
        position: absolute;
        width: 100%;
        left: 0px;
        top: 70px;
        animation: star1-ani 2s ease infinite;
        animation-direction: reverse;

        @keyframes star1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .music {
        position: fixed;
        top: 10px;
        right: 10px;
        width: 35px;

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .star2 {
        position: absolute;
        width: 100%;
        top: 70px;
        left: 0px;
        animation: star2-ani 3s ease infinite reverse;

        @keyframes star2-ani {
            0% {
                opacity: 1;
            }

            50% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .header1 {
        position: absolute;
        width: 300px;
        left: 50%;
        margin-left: -150px;
        top: 35px;
        animation: header1-ani 1.5s ease backwards;

        @keyframes header1-ani {
            0% {
                top: -100px;

            }

            100% {
                top: 35px;

            }
        }
    }

    .header {
        position: absolute;
        width: 250px;
        left: 50%;
        margin-left: -125px;
        top: 95px;
        animation: header-ani 1s ease-out backwards;

        @keyframes header-ani {
            0% {
                top: 110px;
                width: 360px;
                margin-left: -180px;
                opacity: 0;
            }

            100% {
                top: 95px;
                width: 250px;
                margin-left: -125px;
                opacity: 1;

            }
        }
    }

    .jxw {
        position: absolute;
        width: 220px;
        left: 150px;
        top: 215px;
        animation: jxw-ani 3s ease infinite normal;

        @keyframes jxw-ani {
            0% {
                top: 215px;
                left: 150px;
            }

            50% {
                top: 200px;
                left: 140px;
            }

            100% {
                top: 215px;
                left: 150px;
            }
        }
    }

    .hangzhou {
        position: absolute;
        width: 140px;
        left: 20px;
        top: 300px;
    }

    .jinhua {
        position: absolute;
        width: 170px;
        right: 15px;
        top: 370px;
    }

    .down {
        position: absolute;
        top: 600px;
        font-size: 50px;
        left: 20px;
        color: #e4dcdc;
        animation: down-ani 1.5s ease infinite normal;

        @keyframes down-ani {
            0% {
                top: 450px;
                opacity: 1;
            }

            100% {
                top: 580px;
                opacity: 0.5;
            }


        }
    }

    .button {
        position: absolute;
        width: 180px;
        left: 50%;
        margin-left: -90px;
        top: 570px;
        animation: but-ani 2s ease infinite normal;

        @keyframes but-ani {
            0% {
                width: 180px;
                margin-left: -90px;
                top: 560px;
            }

            50% {
                width: 190px;
                margin-left: -95px;
                top: 560px;
            }

            100% {
                width: 180px;
                margin-left: -90px;
                top: 560px;
            }
        }
    }

    .logo {
        position: absolute;
        left: 0px;
        bottom: -100px;
        width: 200px;
        left: 50%;
        margin-left: -100px;
    }

    .tip {
        position: absolute;
        width: 120px;
        left: 50%;
        margin-left: -60px;
        top: 580px;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .close {
            position: absolute;
            left: 20px;
            top: 70px;
            font-size: 40px;
            color: #fff;
        }

        .thewords {
            font-size: 14px;
            color: #FFF;
            position: absolute;
            width: 200px;
            text-align: center;
            top: 76px;
            right: 0px;
        }

        .share {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 70px;
        }

        .box {
            position: absolute;
            background: url("../static/popbox.png") no-repeat;
            background-size: 100% 100%;
            width: 320px;
            height: 460px;
            top: 120px;
            left: 30px;

            .words {
                position: absolute;
                top: 130px;
                width: 100%;
                font-weight: 800;
                text-align: center;
                color: #fff;
                font-size: 32px;

            }

        }
    }


    .bottom-box {
        position: relative;
        top: -200px;
        display: block;
        height: 3500px;

        .bottom-img {

            width: 100%;
        }


    }

}
</style>